/* eslint-disable import/prefer-default-export */

// NOTE: PUBLICLY VISIBLE IN DOM; NAME ACCORDINGLY
// test IDs should be unique per page
export const enum TestId {
  LandingPageLayout = 'landing-layout',
  ArticleContainer = 'article',
  ReferenceContainer = 'reference',
  ApiMember = 'api-member',
  OpenCloudContainer = 'open-cloud-1', // type: cloudapi (v1, open api spec)
  RoasOpenCloudContainer = 'open-cloud-2', // type: cloudapi2 (roblox specific open api spec)
  OpenAPIContainer = 'open-cloud-openapi', // type: cloudfeature/clouddomain (unified openapi spec)
  ReleaseNoteContainer = 'release-notes',
  CommunityPageContainer = 'community',
  CommunityPageContentContainer = 'community-content',
  LessonContainer = 'lesson',
  FeedbackButton = 'feedback-btn',
  FeedbackDialog = 'feedback-dialog',
  FeedbackDialogPositiveRatingButton = 'feedback-dialog-positive-rating-button',
  FeedbackDialogCommentInput = 'feedback-dialog-comment-input',
  FeedbackDialogSubmitBtn = 'feedback-dialog-submit-btn',
  ApiReferenceSummary = 'reference-summary',
  OptInTOS = 'optin-tos',
  OptInPP = 'optin-pp',
  ArrowDropDownRoundedIcon = 'ArrowDropDownRoundedIcon', // TODO For testing auth. Ticket for extending this for mobile: https://roblox.atlassian.net/browse/CRK-4421
  MessagePrompt = 'message-prompt',
  MessageResponse = 'message-response',
  Input = 'input',
  StreamingIndicator = 'streaming-indicator',
  TopNavRightContent = 'nav-right',
  StudioDownloadDialog = 'studio-dialog-download',
  StudioIncompatiblePlatformMessage = 'studio-incompatible-message',
  Sidebar = 'sidebar',
  CopyHeadingLink = 'copy-heading-link',
  LanguageMenuButton = 'language-menu-button',
  OpenSourceEditButton = 'open-source-edit-button',
}
